<div class="add-70">
    <div class="page-banner career-banner">
        <div class="row align-items-center flex-wrap h-100">
            <div class="col-md-4 team-banner-left">
                <img src="assets/img/career_banner_1.svg" height="350rem" alt="Join our team">
            </div>
            <div class="col-md-4 text-center">
                <h2 class="font-600">
                    Interested In
                    <br>
                    Joining The Team?
                </h2>
                <p class="career-enquiry">
                    For inquiries, email us at:
                    <a class="career-email" href="mailto:careers@nuvertos.com">careers@nuvertos.com</a>
                </p>
            </div>
            <div class="col-md-4 text-right team-banner-right">
                <img src="assets/img/career_banner_2.svg" height="350rem" alt="Join our team">
            </div>
        </div>
    </div>
</div>


<div class="careers-block">
    <div class="container">
        <ng-container>
            <div class="career-card text-center">
                <h4 class="font-600 mobile-header text-center mb-4">
                    Click the link below to see all of our job listings!
                </h4>
                <a href="https://timestream.keka.com/careers" target="_blank">
                    <button type="button" class="btn brand-button mb-2">Career Portal
                    </button>
                </a>
            </div>
        </ng-container>
        <!-- <ng-container *ngFor="let dept of fields">
            <div class="mb-5">
                <h3>{{dept.label}}</h3>

                <ng-container *ngIf="careers[dept.dept] && careers[dept.dept].length; else noOpenings">
                    <ng-container *ngFor="let career of careers[dept.dept]">
                        <div class="career-card">
                            <h4 class="font-600 mobile-header">
                                {{career.designation}}
                                <span class="float-right mt-3">
                                    <a (click)="selectRole(career)" class="apply-button">
                                        Apply Now
                                        <img src="assets/img/arrow-top-right.svg" alt="" style="margin-top:-3px">
                                    </a>
                                </span>
                            </h4>
                            <p>
                                {{career.description}}
                            </p>
                            <div class="career-info">
                                <ng-container *ngFor="let info of career.info">
                                    <span class="pill-white">{{info}}</span>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
    


                <ng-template #noOpenings>
                    <div class="mt-3 mb-3">
                        <p>
                            There are no openings for this team as of right now.
                        </p>
                    </div>
                </ng-template>
            </div>

        </ng-container> -->
    </div>
</div>

<!-- <div class="container">
    <iframe src="https://timestream.keka.com/careers/api/embedjobs/61be7622-a429-41d9-9f03-e7c88d9a2605" frameborder="0" height="100%" width="100%"></iframe>
</div> -->

<app-contact-card></app-contact-card>
<app-career-modal [selected_role]="selected_role"></app-career-modal>